(() => {
  const getToggleLabels = (root) => ({
    showMore: root?.dataset.showMoreLabel || '',
    showLess: root?.dataset.showLessLabel || '',
  });

  let cachedPriceHtml = null;

  const getMoneyFormat = () => window.themeVariables?.settings?.moneyFormat;

  const getLocale = () => (window.Shopify?.locale || document.documentElement.lang || '').toLowerCase();
  const isFrLocale = () => getLocale().startsWith('fr');
  const isDeLocale = () => getLocale().startsWith('de');

  const formatMoney = (cents) => {
    if (isFrLocale() || isDeLocale()) {
      return (cents / 100).toFixed(2).replace('.', ',');
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, getMoneyFormat()).trim();
    }
    return `€${(cents / 100).toFixed(2).replace('.', ',')}`;
  };

  const formatPriceHtml = (cents) => {
    const formatted = formatMoney(cents);
    const sep = formatted.includes(',') ? ',' : formatted.includes('.') ? '.' : null;
    const suffix = isFrLocale() || isDeLocale() ? '€' : '';

    if (!sep) {
      return `<span>${formatted}</span>${suffix}`;
    }

    const [main, decimals = ''] = formatted.split(sep);

    if (!decimals || decimals === '00') {
      return `<span>${main}</span>${suffix}`;
    }

    return `<span>${main}</span><span class="product-card__price--cents">,${decimals}</span>${suffix}`;
  };

  const getPriceElements = () => ({
    salePriceEl: document.querySelector('.product-info__price sale-price'),
    comparePriceEl: document.querySelector('.product-info__price compare-at-price'),
    priceContainer: document.querySelector('.product-info__price .product-price-container'),
    discountEl: document.querySelector('.product-info__price .product-card__price--discount'),
    stickySalePriceEl: document.querySelector('.pdp-new-sticky-cta__price sale-price'),
    stickyComparePriceEl: document.querySelector('.pdp-new-sticky-cta__price compare-at-price'),
    stickyPriceContainer: document.querySelector('.pdp-new-sticky-cta__price .product-price-container'),
    stickyDiscountEl: document.querySelector('.pdp-new-sticky-cta__price .product-card__price--discount'),
  });

  const cacheBasePriceHtml = () => {
    if (cachedPriceHtml) return cachedPriceHtml;

    const {
      salePriceEl,
      comparePriceEl,
      priceContainer,
      discountEl,
      stickySalePriceEl,
      stickyComparePriceEl,
      stickyPriceContainer,
      stickyDiscountEl,
    } = getPriceElements();

    cachedPriceHtml = {
      sale: salePriceEl?.innerHTML || '',
      compare: comparePriceEl?.innerHTML || '',
      compareDisplay: comparePriceEl?.style.display || '',
      containerDisplay: priceContainer?.style.display || '',
      discount: discountEl?.innerHTML || '',
      discountDisplay: discountEl?.style.display || '',
      stickySale: stickySalePriceEl?.innerHTML || '',
      stickyCompare: stickyComparePriceEl?.innerHTML || '',
      stickyCompareDisplay: stickyComparePriceEl?.style.display || '',
      stickyContainerDisplay: stickyPriceContainer?.style.display || '',
      stickyDiscount: stickyDiscountEl?.innerHTML || '',
      stickyDiscountDisplay: stickyDiscountEl?.style.display || '',
    };

    return cachedPriceHtml;
  };

  const clearPriceCache = () => {
    cachedPriceHtml = null;
  };

  const setPriceElementHtml = (el, cents) => {
    if (!el) return;
    const srOnly = el.querySelector('.sr-only');
    const srHtml = srOnly ? srOnly.outerHTML : '';
    el.innerHTML = `${srHtml}${formatPriceHtml(cents)}`;
  };

  const restoreBasePriceHtml = () => {
    const cached = cacheBasePriceHtml();
    const {
      salePriceEl,
      comparePriceEl,
      priceContainer,
      discountEl,
      stickySalePriceEl,
      stickyComparePriceEl,
      stickyPriceContainer,
      stickyDiscountEl,
    } = getPriceElements();

    if (salePriceEl) salePriceEl.innerHTML = cached.sale;
    if (comparePriceEl) {
      comparePriceEl.innerHTML = cached.compare;
      comparePriceEl.style.display = cached.compareDisplay;
    }
    if (priceContainer) priceContainer.style.display = cached.containerDisplay;
    if (discountEl) {
      discountEl.innerHTML = cached.discount;
      discountEl.style.display = cached.discountDisplay;
    }

    if (stickySalePriceEl) stickySalePriceEl.innerHTML = cached.stickySale;
    if (stickyComparePriceEl) {
      stickyComparePriceEl.innerHTML = cached.stickyCompare;
      stickyComparePriceEl.style.display = cached.stickyCompareDisplay;
    }
    if (stickyPriceContainer) stickyPriceContainer.style.display = cached.stickyContainerDisplay;
    if (stickyDiscountEl) {
      stickyDiscountEl.innerHTML = cached.stickyDiscount;
      stickyDiscountEl.style.display = cached.stickyDiscountDisplay;
    }
  };

  const updateSavingsBadge = (totalPrice, totalCompare) => {
    const { discountEl, stickyDiscountEl } = getPriceElements();
    const badges = [discountEl, stickyDiscountEl].filter(Boolean);
    if (!badges.length) return;

    const savingsCents = totalCompare - totalPrice;

    badges.forEach((badge) => {
      if (savingsCents <= 0) {
        badge.style.display = 'none';
        return;
      }

      const saveLabel = badge.dataset.saveLabel || '';
      const formattedSavings = formatMoney(savingsCents);
      const inner = badge.querySelector('span') || badge;

      badge.style.display = '';
      inner.textContent = saveLabel ? `${saveLabel} ${formattedSavings}` : formattedSavings;
    });
  };

  const hasCheckedComplementary = () =>
    document.querySelectorAll('[data-complementary-products-new] [data-complementary-checkbox]:checked').length > 0;

  const getBasePrices = (priceInner) => {
    const basePrice = Number(priceInner.dataset.basePrice || 0);
    const baseCompare = Number(priceInner.dataset.baseCompare || basePrice);
    return { basePrice, baseCompare };
  };

  const updateMainProductPrice = () => {
    const priceInner = document.querySelector('.product-info__price--inner[data-base-price]');
    const stickyPriceInner = document.querySelector('.pdp-new-sticky-cta__price [data-base-price]');
    const priceInners = [priceInner, stickyPriceInner].filter(Boolean);
    if (!priceInners.length) return;

    if (!hasCheckedComplementary()) {
      restoreBasePriceHtml();
      return;
    }

    const { basePrice, baseCompare } = getBasePrices(priceInners[0]);
    let addPrice = 0;
    let addCompare = 0;

    document.querySelectorAll('[data-complementary-products-new] [data-complementary-checkbox]:checked').forEach((checkbox) => {
      addPrice += Number(checkbox.dataset.price) || 0;
      addCompare += Number(checkbox.dataset.comparePrice) || Number(checkbox.dataset.price) || 0;
    });

    const totalPrice = basePrice + addPrice;
    const totalCompare = baseCompare + addCompare;
    const {
      salePriceEl,
      comparePriceEl,
      priceContainer,
      stickySalePriceEl,
      stickyComparePriceEl,
      stickyPriceContainer,
    } = getPriceElements();

    [salePriceEl, stickySalePriceEl].filter(Boolean).forEach((el) => setPriceElementHtml(el, totalPrice));

    [comparePriceEl, stickyComparePriceEl].forEach((compareEl, index) => {
      const container = index === 0 ? priceContainer : stickyPriceContainer;
      if (!compareEl || !container) return;

      if (totalCompare > totalPrice) {
        setPriceElementHtml(compareEl, totalCompare);
        compareEl.style.display = '';
        container.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    });

    updateSavingsBadge(totalPrice, totalCompare);
  };

  const syncComplementarySelection = (root) => {
    if (!root) return;

    const output = root.querySelector('[data-complementary-output]');
    const selectedVariantIds = Array.from(
      root.querySelectorAll('[data-complementary-checkbox]:checked')
    ).map((item) => Number(item.dataset.variantId)).filter(Boolean);

    if (output) {
      output.value = JSON.stringify(selectedVariantIds);
    }

    root.dispatchEvent(
      new CustomEvent('complementary-products:change', {
        bubbles: true,
        detail: { selectedVariantIds },
      })
    );

    updateMainProductPrice();
  };

  const initShowMore = (root) => {
    const toggle = root.querySelector('[data-cp-new-toggle]');
    const extra = root.querySelector('[data-cp-new-extra]');
    const label = root.querySelector('[data-cp-new-toggle-label]');
    if (!toggle || !extra || toggle.dataset.cpNewToggleInit === 'true') return;

    toggle.dataset.cpNewToggleInit = 'true';
    const { showMore, showLess } = getToggleLabels(root);

    // After a color/set swap this can run twice on the same element (the
    // MutationObserver inits on insert, shopify:section:load resets the init
    // flags and inits again). Two listeners toggle the class twice per
    // click, so the list never opens — remove the previous handler first.
    if (toggle._cpNewToggleHandler) {
      toggle.removeEventListener('click', toggle._cpNewToggleHandler);
    }
    toggle._cpNewToggleHandler = () => {
      const isExpanded = extra.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      if (label) {
        label.textContent = isExpanded ? showLess : showMore;
      }
    };
    toggle.addEventListener('click', toggle._cpNewToggleHandler);
  };

  const initComplementaryBlock = (root) => {
    if (!root || root.dataset.cpNewInit === 'true') return;
    root.dataset.cpNewInit = 'true';
    initShowMore(root);
  };

  const resetComplementaryBlocks = (scope = document) => {
    scope.querySelectorAll('[data-complementary-products-new]').forEach((root) => {
      delete root.dataset.cpNewInit;
      root.querySelectorAll('[data-cp-new-toggle]').forEach((toggle) => {
        delete toggle.dataset.cpNewToggleInit;
      });
      initComplementaryBlock(root);
    });
  };

  const scan = (scope = document) => {
    scope.querySelectorAll('[data-complementary-products-new]').forEach(initComplementaryBlock);
  };

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('[data-complementary-products-new] [data-complementary-checkbox]');
    if (!checkbox) return;

    const root = checkbox.closest('[data-complementary-products-new]');
    syncComplementarySelection(root);
  });

  document.addEventListener('complementary-products:change', updateMainProductPrice);

  document.addEventListener('DOMContentLoaded', () => {
    cacheBasePriceHtml();
    scan();
  });

  document.addEventListener('shopify:section:load', (event) => {
    clearPriceCache();
    resetComplementaryBlocks(event.target);
    requestAnimationFrame(() => {
      cacheBasePriceHtml();
    });
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('[data-complementary-products-new]')) {
          initComplementaryBlock(node);
        } else {
          scan(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.initComplementaryProductsNew = resetComplementaryBlocks;
  window.updateComplementaryPdpPrice = updateMainProductPrice;
  window.clearComplementaryPdpPriceCache = clearPriceCache;
  window.cacheComplementaryPdpPrice = cacheBasePriceHtml;
})();
